import {RouteEnum} from "@/router/RouteEnum.ts";
import DashboardView from "@/views/DashboardView.vue";
import SynchronizationStepper from "@/components/SynchronizationStepper.vue";
import CardsView from "@/views/CardsView.vue";


const dashboard = {
  path: '/sync',
  name: RouteEnum.Dashboard,
  component: DashboardView,
}

const syncWithOwner = {
  path: '/sync/:sourceLeft/:sourceRight/:ownerId/:type',
  name: RouteEnum.SyncWithOwner,
  components: {
    default: CardsView,
    headerCenter: SynchronizationStepper
  },
  props: true,
}
const syncWithoutOwner = {
  path: '/sync/:sourceLeft/:sourceRight/:type',
  name: RouteEnum.SyncWithoutOwner,
  components: {
    default: CardsView,
    headerCenter: SynchronizationStepper
  },
  props: true,
}
const synchroRoutes = [
  dashboard,
  syncWithoutOwner,
  syncWithOwner
]

export default synchroRoutes
